import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthState } from './auth.state';

@Injectable()
export class ApiClientService {
  constructor(
    private store: Store,
    private http: HttpClient,
    private router: Router
  ) {}

  get(url: string): any {
    return this.http
      .get<any>(environment.apiHost + '/api/v1' + url, {
        ...this.options(),
        ...{ observe: 'response' }
      })
      .map((res: HttpResponse<any>) => {
        const response = res.body;
        if (res.headers.keys().indexOf('X-Doc-Link') !== -1)
          response.docLink = res.headers.get('X-Doc-Link');
        return response;
      })
      .catch(this.handleError());
  }

  patch(url: string, payload: Object): any {
    return this.http
      .patch(environment.apiHost + '/api/v1' + url, payload, this.options())
      .catch(this.handleError());
  }

  post(url: string, payload: Object): any {
    return this.http
      .post(environment.apiHost + '/api/v1' + url, payload, this.options())
      .catch(this.handleError());
  }

  delete(url: string): any {
    return this.http
      .delete(environment.apiHost + '/api/v1' + url, this.options())
      .catch(this.handleError());
  }

  private handleError() {
    return (error: any) => {
      const errMsg = error.message
        ? error.message
        : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
      console.error(errMsg); // log to console
      if (error.status === 422) return throwError(error.error);
      if (error.status === 401)
        // FIXME: should be this.store.dispatch(new Logout()); but is buggy in NGXS-Router-Plugin in version 3.5.1
        return this.router.navigate(['/external/logout']);
      return throwError(error);
    };
  }

  private options() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.store.selectSnapshot(AuthState.token),
      'X-Key-Inflection': 'camel'
    });
    return { headers: headers };
  }
}
